import { DefaultLocale } from '../..';
import i18n from '../configuration';

const auth0ErrorKeys = [
  'auth0.errors.unexpectedError',
  'auth0.errors.unauthorized',
  'auth0.errors.invalidCredentials',
  'auth0.errors.mustResetPassword',
  'auth0.errors.userNotFound',
  'auth0.errors.userIdInvalid',
  'auth0.errors.userCreationFailed',
  'auth0.errors.userExists',
  'auth0.errors.validationError',
  'auth0.errors.invalidEmail',
  'auth0.errors.loginInvalidError'
];

export function normalizeLocale(locale?: string): string | undefined {
    if (!locale) {
      return DefaultLocale;
    }
    
    const shortenedToFullLocaleMapping: Record<string, string> = {
      'de': 'de-DE',
      'en': 'en-US',
      'es': 'es-ES',
      'it': 'it-IT',
      'ja': 'ja-JP',
      'nl': 'nl-NL',
      'th': 'th-TH',
    };
    
    return shortenedToFullLocaleMapping[locale] || locale;
  }

function normalizeForComparison(value: string): string {
    return value
        .replace(/[‘’]/g, "'")
        .replace(/[“”]/g, '"')
        .toLowerCase();
}

export function translateAuth0ErrorByMessage(
    message: string,
    locale: string,
    normalizeUnicodeQuotes = false
): string | null {
    const normalize = normalizeUnicodeQuotes
        ? normalizeForComparison
        : (value: string) => value.toLowerCase();
    const normalizedMessage = normalize(message);

    const matchingKey = auth0ErrorKeys.find((key) => {
        const englishTranslation = i18n.t(key, { lng: DefaultLocale });

        return normalize(englishTranslation) === normalizedMessage;
    });

    if (matchingKey) {
    return i18n.t(matchingKey, { lng: normalizeLocale(locale) });
    }

    return null;
}